export default class CardSlopedCollapsable {
    static CARD_SLOPED_COLLAPSE_BUTTONS_SELECTOR = '.js-toggle-collapse'

    constructor() {
        this.collapseButtons = document.querySelectorAll(CardSlopedCollapsable.CARD_SLOPED_COLLAPSE_BUTTONS_SELECTOR)
        this.initEventListener()
    }

    /**
     * Add click event listener for all collapse buttons
     */
    initEventListener() {
        this.collapseButtons.forEach((collapseButton) => {
            collapseButton.addEventListener('click', (event) => {
                this.toggleCollapse(collapseButton)
            })
        })
    }

    /**
     * Toggles the class to show more/less content
     * @param collapseButton
     */
    toggleCollapse(collapseButton) {
        collapseButton.closest('.card-sloped').classList.toggle('show-more')
    }
}
